import { ThreeSixtyViewIcon, VideoIcon } from "@/components/Icons";
import { Property } from "@/interfaces/property.interface";

interface PropertyMediaInfoProps {
  property: Property;
}
export const PropertyMediaInfo = ({ property }: PropertyMediaInfoProps) => {
  if (!property.view360Url && !property.videoTourUrl) {
    return <></>;
  }

  return (
    <div className="absolute bottom-3 ltr:right-2 rtl:left-2 flex gap-2">
      {property.view360Url && (
        <div className="bg-black/95 rounded-xl px-2 py-1.5 pointer-events-none">
          <ThreeSixtyViewIcon className="size-6 fill-white" />
        </div>
      )}
      {property.videoTourUrl && (
        <div className="bg-black/95 rounded-xl px-2 py-1.5 flex items-center gap-2 pointer-events-none">
          <VideoIcon className="size-7 fill-white" />
        </div>
      )}
    </div>
  );
};
